export const GLOBAL_LABELS = 'global';
export const GLOBAL_ADD_TO_BAG_MODAL_LABELS = 'global.addedToBagModal';

export const price = 'lbl_info_price';
export const bagSubTotal = 'lbl_info_subTotal';
export const totalRewardsInPoints = 'lbl_info_totalRewardsInBag';
export const totalNextRewards = 'lbl_info_totalNextRewards';

const AddedToBagViewPointsLabels = {
  global: {
    addedToBagModal: {
      [price]: 'Price',
      [bagSubTotal]: 'Bag Subtotal (#items items)',
      [totalRewardsInPoints]: 'Total My Place Reward Points in Bag',
      [totalNextRewards]: 'Total Points To Next Reward',
    },
  },
};

export default AddedToBagViewPointsLabels;
